
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"matrix(2,0,0,2,0,0)"}},[_c('g',[_c('path',{staticStyle:{"fill":"currentColor"},attrs:{"d":"M18.5,0H5.5A5.51,5.51,0,0,0,0,5.5v13A5.51,5.51,0,0,0,5.5,24h13A5.51,5.51,0,0,0,24,18.5V5.5A5.51,5.51,0,0,0,18.5,0ZM20,16a4,4,0,0,1-4,4H8a4,4,0,0,1-4-4V8A4,4,0,0,1,8,4h8a4,4,0,0,1,4,4Z"}}),_c('circle',{staticStyle:{"fill":"currentColor"},attrs:{"cx":"12","cy":"12","r":"4"}}),_c('circle',{staticStyle:{"fill":"currentColor"},attrs:{"cx":"17","cy":"7","r":"1"}})])])])
          )
        }
      }
    